import { USE_CT_AS_DATA_SOURCE_FOR_PLP_AND_SEARCH } from '~~/constants/useCtAsDataSourceForPlpAndSearch';
import type { CountryCodeValue } from '~~/types/localization/localizationHelperTypes';

// Temporary switch between CT and Typesense, deleted together with Typesense.
// Reads the country from $i18n rather than useLocalization so route middleware can use it too.
export const useIsCtProductSearchEnabled = () => {

  const { $i18n } = useNuxtApp();

  const isCtProductSearchEnabled = computed(
    () => USE_CT_AS_DATA_SOURCE_FOR_PLP_AND_SEARCH[$i18n.localeProperties.value.country as CountryCodeValue],
  );

  return {
    isCtProductSearchEnabled,
  };

};
